import type { Table } from "./DataTable";

// Expand row/column spans into a full grid; spanned values repeat so every row stands alone in Excel
export function tableToGrid(table: Table): string[][] {
  const grid: string[][] = [];
  const flags: boolean[] = [];
  table.rows.forEach((row, r) => {
    grid[r] = grid[r] ?? [];
    let c = 0;
    row.forEach((cell) => {
      while (grid[r][c] !== undefined) c++;
      const text = cell.parts ? cell.parts.map((p) => p.p ?? "").filter(Boolean).join("\n\n") : cell.t;
      for (let i = 0; i < (cell.rs ?? 1); i++) {
        grid[r + i] = grid[r + i] ?? [];
        for (let j = 0; j < (cell.cs ?? 1); j++) grid[r + i][c + j] = j === 0 ? text : "";
      }
      if (cell.a) flags[r] = true;
      c += cell.cs ?? 1;
    });
  });
  const width = table.head.length;
  const body = grid
    .map((row, r) => ({ row: Array.from({ length: width }, (_, k) => row?.[k] ?? ""), assured: !!flags[r] }))
    .filter(({ row }) => row.some((v) => v))
    .filter(({ row }, i, all) => i === 0 || row.join("\u0001") !== all[i - 1].row.join("\u0001"))
    .map(({ row, assured }) => [...row, assured ? "Yes" : ""]);
  return [[...table.head, "Assured by ERM CVS"], ...body];
}

const esc = (v: string) => (/[",\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v);

export function downloadCsv(filename: string, grid: string[][]) {
  const csv = "\uFEFF" + grid.map((row) => row.map(esc).join(",")).join("\r\n");
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
